import React, { useState, useEffect } from 'react';
import { getFirebaseStatus } from '../../utils/testFirebase';

const FirebaseStatus: React.FC = () => {
  const [status, setStatus] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const firebaseStatus = getFirebaseStatus();
    setStatus(firebaseStatus);
  }, []);

  if (!status) return null;

  return (
    <>
      <button
        onClick={() => setIsVisible(!isVisible)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          background: status.configured ? '#22c55e' : '#ef4444',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          fontSize: '18px',
          zIndex: 1000
        }}
        title={`Firebase Status: ${status.configured ? 'Connected' : 'Disconnected'}`}
      >
        🔥
      </button>

      {isVisible && (
        <div style={{
          position: 'fixed',
          bottom: '80px',
          right: '20px',
          background: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '16px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          minWidth: '250px',
          zIndex: 1000
        }}>
          <div style={{ marginBottom: '12px' }}>
            <strong>Firebase Status</strong>
          </div>
          
          <div style={{ fontSize: '14px', color: '#6b7280' }}>
            <div style={{ marginBottom: '4px' }}>
              Project: <span style={{ fontWeight: 'bold' }}>{status.projectId}</span>
            </div>
            <div style={{ marginBottom: '8px' }}>
              Domain: <span style={{ fontWeight: 'bold' }}>{status.authDomain}</span>
            </div>
            
            <div style={{ marginBottom: '4px' }}>
              <span style={{ color: status.services.auth ? '#22c55e' : '#ef4444' }}>
                {status.services.auth ? '✓' : '✗'} Authentication
              </span>
            </div>
            <div style={{ marginBottom: '4px' }}>
              <span style={{ color: status.services.firestore ? '#22c55e' : '#ef4444' }}>
                {status.services.firestore ? '✓' : '✗'} Firestore
              </span>
            </div>
            <div style={{ marginBottom: '4px' }}>
              <span style={{ color: status.services.storage ? '#22c55e' : '#ef4444' }}>
                {status.services.storage ? '✓' : '✗'} Storage
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FirebaseStatus;